import IllustrationDisclosure_GroupEN1 from '../PDFGeneration/Compliance/IllustrationDisclosure_GroupEn1.png';
import IllustrationDisclosure_AchEN1 from '../PDFGeneration/Compliance/IllustrationDisclosure_AchEn1.png';
import IllustrationDisclosure_SIEN1 from '../PDFGeneration/Compliance/IllustrationDisclosure_SIEn1.png';
import IllustrationDisclosure_GroupFR1 from '../PDFGeneration/Compliance/IllustrationDisclosure_GroupFr1.png';
import IllustrationDisclosure_AchFR1 from '../PDFGeneration/Compliance/IllustrationDisclosure_AchFr1.png';
import IllustrationDisclosure_SIFR1 from '../PDFGeneration/Compliance/IllustrationDisclosure_SIFr1.png';
import { PLAN_TYPE_IDS } from '../Utils/PlanUtils';
import './Quotes.css'
import { useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import { sprintf } from "../Utils/FormattingUtils";
import { useTranslation } from "react-i18next";

const IllustrationDisclosure = ({ state, setQuoteImage, hideSignatures, page, totalPages }) => {

    const componentRef = useRef(); // Reference to the component

    const { t } = useTranslation();

    //Similar to how we are generating PDF pages for each deposit mode, we can generate an image of the disclosure page
    useEffect(() => {
        if (!setQuoteImage || !componentRef.current) {
            return;
        }

        html2canvas(componentRef.current).then((canvas) => {
            setQuoteImage(canvas.toDataURL('image/png'));
        });

    }, [setQuoteImage, componentRef.current]);

    const pageCountLabel = () => {
        if (!page || !totalPages) {
            return '';
        }
        return sprintf(t('x of y'), page, totalPages);
    }

    return (
        <div ref={componentRef} className={'illustration-disclosure'}>
            {state.plan.planTypeID === PLAN_TYPE_IDS.GROUP &&
                <img src={IllustrationDisclosure_GroupEN1} />
            }
            {state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS &&
                <img src={IllustrationDisclosure_AchEN1} />
            }
            {state.plan.planTypeID === PLAN_TYPE_IDS.SI &&
                <img src={IllustrationDisclosure_SIEN1} />
            }
            {hideSignatures &&
                <div className={'illustration-disclosure-signature-hider'}></div>
            }
            <div className={'illustration-disclosure-page'}>{pageCountLabel()}</div>
        </div>
    )

    /*
    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        return (
            <div ref={componentRef} className={'illustration-disclosure'}>
                <img src={IllustrationDisclosure_GroupEN1}/>
                {hideSignatures &&
                    <div className={'illustration-disclosure-signature-hider'}></div>
                }
                <div className={'illustration-disclosure-page'}>{pageCountLabel()}</div>
            </div>
        )
    }
    if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        return (
            <div ref={componentRef} className={'illustration-disclosure'}>
                <img src={IllustrationDisclosure_AchEN1}/>
                {hideSignatures &&
                    <div className={'illustration-disclosure-signature-hider'}></div>
                }
                <div className={'illustration-disclosure-page'}>{pageCountLabel()}</div>
            </div>
        )
    }
    if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        return (
            <div ref={componentRef} className={'illustration-disclosure'}>
                <img src={IllustrationDisclosure_SIEN1}/>
                {hideSignatures &&
                    <div className={'illustration-disclosure-signature-hider'}></div>
                }
                <div className={'illustration-disclosure-page'}>{pageCountLabel()}</div>
            </div>
        )
    }

     */
}

export default IllustrationDisclosure;